/**
 * 管理后台用户接口
 * 管理后台用户接口API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The AccountFreezeUpsertForm model module.
   * @module account_mgt/model/AccountFreezeUpsertForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>AccountFreezeUpsertForm</code>.
   * @alias module:account_mgt/model/AccountFreezeUpsertForm
   * @class
   * @param freezeUntil {Date} 冻结截止时间
   */
  var exports = function(freezeUntil) {
    var _this = this;

    _this['freezeUntil'] = freezeUntil;

  };

  /**
   * Constructs a <code>AccountFreezeUpsertForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:account_mgt/model/AccountFreezeUpsertForm} obj Optional instance to populate.
   * @return {module:account_mgt/model/AccountFreezeUpsertForm} The populated <code>AccountFreezeUpsertForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'freezeUntil')) {
        obj['freezeUntil'] = ApiClient.convertToType(data['freezeUntil'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'reason')) {
        obj['reason'] = ApiClient.convertToType(data['reason'], 'String');
      }
    }
    return obj;
  }

  /**
   * 冻结截止时间
   * @member {Date} freezeUntil
   */
  exports.prototype['freezeUntil'] = undefined;
  /**
   * 冻结原因
   * @member {String} reason
   */
  exports.prototype['reason'] = undefined;



  export default exports;
;


